<form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2 form-horizontal">
    <div class="form-group row">
        <div class="col-md-4">
            <yt-fw-date-picker-popup 
                name="txtOdDatuma" 
                formControlName="OdDatuma" 
                [ngClass]="{'is-invalid' : submitted && fc.OdDatuma.invalid}"
                [Label]="'IZVESTAJONENAPLACENIMRACUNIMA.ODDATUMA.SINGULAR'">
                </yt-fw-date-picker-popup>
            <div class="form-error" *ngIf="submitted && fc.OdDatuma.invalid">
                <span *ngFor="let validation of errorMessages.OdDatuma">
                    <span class="error-message" *ngIf="fc.OdDatuma.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                </span>
            </div>
        </div>
        <div class="col-md-4">
            <yt-fw-date-picker-popup 
                name="txtDoDatuma" 
                formControlName="DoDatuma" 
                [ngClass]="{'is-invalid' : submitted && fc.DoDatuma.invalid}"
                [Label]="'IZVESTAJONENAPLACENIMRACUNIMA.DODATUMA.SINGULAR'">
            </yt-fw-date-picker-popup>
            <div class="form-error" *ngIf="submitted && fc.DoDatuma.invalid">
                <span *ngFor="let validation of errorMessages.DoDatuma">
                    <span class="error-message" *ngIf="fc.DoDatuma.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                </span>
            </div>
        </div>
    </div>
    <div class="form-group row">
        <div class="col-md-8">
            <yt-multiselect 
            [ModelName]="'orgjed'" 
            [GetName]="'getParentAndChildByParentID'" 
            [ModelProperty]="'Naziv'"
            [OrderBy]="'Naziv'" 
            formControlName="OrgJedIDS" 
            [Type]="'ID'" 
            [Label]="'IZVESTAJONENAPLACENIMRACUNIMA.ORGJED.SINGULAR'"
            [ngClass]="{'is-invalid': submitted && fc.OrgJedIDS.invalid}" 
            (GetItems)="SkupiOrgJed($event)"
            [AllowAddNew]="false"
            >
            </yt-multiselect>
            <div class="form-error" *ngIf="submitted && fc.OrgJedIDS.invalid">
                <span *ngFor="let validation of errorMessages.OrgJedIDS">
                    <span class="error-me ssage" *ngIf="fc.OrgJedIDS.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                </span>
            </div>
        </div>
    </div>

    <div class="form-group row">
            <div class="col-md-8">
              <yt-multiselect
                            [ModelName]="'komitent'"
                            [GetName]="'get'"
                            [ModelProperty]="'SNaziv'"
                            [OrderBy]="'SNaziv'"
                            formControlName="KomitentID"
                            [Type]="'ID'"
                            [Label]="'IZVESTAJONENAPLACENIMRACUNIMA.KOMITENTNAZIV.SINGULAR'"
                            [ngClass]="{'is-invalid': submitted && fc.KomitentID.invalid}"
                            [AllowAddNew]="false" 
                            >
               </yt-multiselect>
               <div class="form-error" *ngIf="submitted && fc.KomitentID.invalid">
                <span *ngFor="let validation of errorMessages.KomitentID">
                  <span class="error-message" *ngIf="fc.KomitentID.hasError(validation.type)">
                    <span [ngClass]="{'slideInRight': fc.KomitentID.hasError(validation.type), 'animated': true}" translate="{{validation.message}}"></span>
                  </span>
                </span>
              </div>
            </div>
        </div>

          <div class="form-group row">
            <div class="col-md-8">
                <yt-number-input-v3
                name="txtPragTolerancije" 
                [Label]="'IZVESTAJONENAPLACENIMRACUNIMA.PRAGTOLERANCIJE.SINGULAR'" 
                formControlName="PragTolerancije"
            >
            </yt-number-input-v3>
            <!-- <div class="form-error" *ngIf="submitted && fc.PragTolerancije.invalid">
                <span *ngFor="let validation of errorMessages.PragTolerancije">
                    <span class="error-message" *ngIf="fc.PragTolerancije.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                </span>
            </div> -->
            </div>
        </div>
        <div class="form-group row">
            <div class="col-md-8">
                <yt-radio-buttons-group
                [Items]="rbItems"
                formControlName="RokIznos">
              </yt-radio-buttons-group>
            </div>
        </div>
            <div class="row">
                <div class="col-md-12">
                    <button type="button" class="btn btn-primary" (click)="LoadPDF()">Štampaj izveštaj</button>
                </div>
            </div>
</form>
